/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".red-tooltip{background-color:red!important}.green-tooltip{background-color:green!important}"];
export { styles as styles };
